module.exports = __webpack_public_path__ + "img/ico_seguros.03c1332c.svg";